/* arubana-pdp-zoom.js
   PDP gallery zoom you can actually move around.

   Before this, sections/arubana-pdp.liquid did the entire "zoom" with one CSS
   rule - `.ar-gallery-main:hover img{transform:scale(1.55)}` - and nothing ever
   set transform-origin, so it always magnified the dead centre of the photo and
   clipped everything else away. Verified on live: transform-origin computed to
   exactly half the box on both axes. On touch it was worse - the tap latched the
   sticky :hover state, so the photo zoomed and then sat frozen at centre with no
   way to reach the edges.

   Two behaviours, matched to the input device:

   - Fine pointer (mouse/trackpad): the magnifier follows the cursor by moving
     transform-origin. transform-origin is deliberately NOT in the section's
     transition list (only `transform` is), so origin changes land instantly and
     tracking feels 1:1 rather than lagging behind the pointer.

   - Touch, and click as a fallback: toggles `.ar-zoomed`, which swaps the
     container to overflow:auto around an oversized image (see the matching
     block in arubana-overrides.css). Panning is then NATIVE scrolling, so
     momentum, rubber-banding and pinch all come for free and there is no
     hand-rolled gesture maths to get wrong. The tapped point is centred on entry.

   Zoom always resets when the displayed photo changes - otherwise you would be
   left scrolled into the corner of a picture you are no longer looking at.
*/
(function () {
  var main = document.querySelector('.ar-gallery-main');
  if (!main) return;
  var img = main.querySelector('img');
  if (!img) return;

  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function zoomOut() {
    main.classList.remove('ar-zoomed');
    main.scrollLeft = 0;
    main.scrollTop = 0;
  }

  function zoomInAt(clientX, clientY) {
    var r = main.getBoundingClientRect();
    var fx = (clientX - r.left) / r.width;
    var fy = (clientY - r.top) / r.height;
    img.style.transformOrigin = '';
    main.classList.add('ar-zoomed');
    // Scroll extents only exist once the class has landed and the image is
    // oversized, so read them after adding the class, not before.
    main.scrollLeft = fx * (main.scrollWidth - main.clientWidth);
    main.scrollTop = fy * (main.scrollHeight - main.clientHeight);
  }

  if (finePointer) {
    main.addEventListener('mousemove', function (e) {
      if (main.classList.contains('ar-zoomed')) return;
      var r = main.getBoundingClientRect();
      img.style.transformOrigin =
        ((e.clientX - r.left) / r.width) * 100 + '% ' +
        ((e.clientY - r.top) / r.height) * 100 + '%';
    });
    main.addEventListener('mouseleave', function () {
      img.style.transformOrigin = '';
    });
  }

  // A pan gesture can still end in a click, so only a genuinely stationary
  // press counts as a tap - otherwise dragging to look around would zoom you
  // straight back out again.
  var startX = 0;
  var startY = 0;
  var dragged = false;

  main.addEventListener('pointerdown', function (e) {
    startX = e.clientX;
    startY = e.clientY;
    dragged = false;
  });
  main.addEventListener('pointerup', function (e) {
    dragged = Math.abs(e.clientX - startX) > 8 || Math.abs(e.clientY - startY) > 8;
  });
  // Touch scrolling inside the zoomed box cancels the pointer stream rather
  // than completing it; treat that as a drag so it never reads as a tap.
  main.addEventListener('pointercancel', function () {
    dragged = true;
  });

  main.addEventListener('click', function (e) {
    if (dragged) return;
    if (main.classList.contains('ar-zoomed')) zoomOut();
    else zoomInAt(e.clientX, e.clientY);
  });

  Array.prototype.forEach.call(document.querySelectorAll('.ar-thumb'), function (t) {
    t.addEventListener('click', zoomOut);
  });

  // Variant switches swap the src directly (see arSync in arubana-pdp.liquid),
  // which no click handler above would catch.
  if (window.MutationObserver) {
    new MutationObserver(zoomOut).observe(img, {
      attributes: true,
      attributeFilter: ['src']
    });
  }
})();
